<template>
  <div>
    <div class="home">
      <Navbar />
    </div>

    <div>
      <div>
        <Header
          title="Tableros de 24 Ministerios "
          postTitle="Se exploran datos de 269 servicios."
          paragraph="Los siguientes visores permiten explorar datos de dotación de personal de los distintos ministerios. Cada visor cuenta con una breve explicación o ejemplo de uso para facilitar su comprensión. Se muestran indicadores de Dotación, Remuneración y Longevidad, que son filtrados de acuerdo a distintos parámetros: Sexo, Estamento, Profesión, Grado y Región."
          image="/img_fondef/portada/portada.png"
        />
      </div>
      <b-container>
        <NavBar2 />
        <br />
        <br />
        <p class="blockquote-footer">
          En esta página se pueden explorar los datos de dotación de personal de
          24 Ministerios (no se incluye el Ministerio de Salud, que será
          analizado de manera separada). La estructura de los datos es compleja
          al estar formada por múltiples niveles. Los individuos están anidados
          dentro de los servicios y estos a su vez están anidados dentro de los
          ministerios. Además, algunas de las variables contienen registros que
          varían a través del tiempo.
        </p>
        <br />
        <p>
          Los distintos servicios son caracterizados por sus
          <i>“dimensiones”</i>, dadas por indicadores construidos con los datos
          crudos. Las dimensiones básicas aquí mostradas son: la
          <strong>dotación</strong> definida como el número de individuos que
          constituyen el personal del servicio. La dotación “filtrada” por sexo,
          régimen de contratación o Región administrativa caracteriza las
          distintas composiciones de cada servicio. La
          <strong>longevidad</strong> del funcionario se calcula a partir de las
          fechas de ingreso/salida del servicio. La
          <strong>remuneración</strong> es el salario promedio anual recibido
          por el funcionario.
        </p>
        <br /><br />
        <blockquote class="blockquote">
          <p class="lead">
            TABLERO: REMUNERACIÓN - DOTACIÓN -LONGEVIDAD
          </p>
          <footer class="blockquote-footer">
            Este visor explora los servicios del Estado Central de acuerdo a
            tres indicadores:
            <strong>Remuneración, Longevidad y Dotación</strong>, que están
            dados para cada servicio. Tanto la remuneración como la longevidad
            son valores promedios para el servicio especificado. La longevidad
            se mide en meses. El periodo de observación máximo es de 11 años
            correspondiente al intervalo desde enero del 2010 a diciembre del
            2020, por lo que la longevidad máxima de un funcionario no puede
            sobrepasar 132 meses.  Es bueno aclarar que no todos los servicios
            tienen igual longevidad máxima, dado que algunos de ellos son de
            reciente creación.<br /><br />
            Para interaccionar con el visor se puede: 1) Cliquear sobre
            cualquier barra para especificar un ministerio, 2) Modificar el año,
            3) Cliquear sobre los diagramas circulares para filtrar por sexo o
            régimen de contratación. La sección de reporte detallado ofrece
            además los valores numéricos para la Dotación, Remuneración promedio
            del servicio y Longevidad promedio del personal del servicio.
          </footer>
        </blockquote>
        <PowerBI
          url="https://app.powerbi.com/view?r=eyJrIjoiMzgxOGE1M2YtNDRkOC00NDczLTg5OWItYTVmNTE5NGNiMzU0IiwidCI6ImI1ZDc4OTI3LTI1ZDAtNDRhOS04MzcwLWQ4NmU1N2M3YmE5NiIsImMiOjR9"
        />
        <br /><br /><br />

        <blockquote class="blockquote">
          <p class="lead">
            TABLERO: DOTACIÓN - REGIONES
          </p>
          <footer class="blockquote-footer">
            Este visor muestra las métricas
            <strong>Dotación, Remuneración y Longevidad</strong>
            distribuidas por Región. Se pueden usar los filtros para responder a
            una gran variedad de consultas. Por ejemplo: Suponga que se requiere
            hacer un estudio sobre la distribución de la dotación de abogados
            por región en el servicio Dirección General de Aguas (DGA).
          </footer>
        </blockquote>
        <p>
          Los pasos sugeridos para esta consulta son los siguientes:
        </p>
        <ol>
          <li>Coloque el filtro de años en 2020.</li>
          <li>
            Borre cualquier selección de género en Sexo ( a menos que quiera
            saber en particular, cuántos abogados mujeres/hombres prestan
            servicios en la DGA).
          </li>
          <li>Seleccione el "Ministerio de Obras Públicas" en Ministerios.</li>
          <li>Seleccione "Dirección General de Aguas (DGA)" en Servicios.</li>
          <li>Finalmente, seleccione "abogado" en Profesión.</li>
        </ol>
        <PowerBI
          url="https://app.powerbi.com/view?r=eyJrIjoiODM1YzlhMjMtOTVjZS00ZDViLTk4NDgtNjI3YzU1YjYyMmU0IiwidCI6ImI1ZDc4OTI3LTI1ZDAtNDRhOS04MzcwLWQ4NmU1N2M3YmE5NiIsImMiOjR9"
        />
        <br /><br /><br />

        <blockquote class="blockquote">
          <p class="lead">
            TABLERO: REMUNERACIÓN - LONGEVIDAD
          </p>
          <footer class="blockquote-footer">
            En este visor se ofrece una perspectiva de las distribuciones de
            <strong>Remuneración</strong> y <strong>Longevidad</strong> del
            personal del Estado de acuerdo al Sexo. Puede utilizar los filtros
            para evidenciar, por ejemplo, las diferencias salariales entre
            hombres y mujeres por Ministerio y Servicios. Estas diferencias
            pueden estar matizadas además por Región y por Grado. El análisis
            puede incorporar también la evolución temporal, al considerar once
            años de datos en la visualización de barras agrupadas. Los diagramas
            de violín que aparecen en el lado izquierdo del visor se construyen
            con muestras de los datos y visualizan la distribución de salarios y
            longevidad para dar una idea mas allá de los valores promedios que
            aparecen en las etiquetas. Como referencia, se incluye también la
            Dotación del Servicio y su Longevidad máxima (Max.Longevidad).<br /><br />
            Para interaccionar con el visor se puede 1) Cliquear sobre
            cualquiera de las gráficas para especificar “Hombre” o “Mujer”, 2)
            Seleccionar un Grado, 3) Seleccionar una Región, 3) Marcar una
            opción de Régimen de contratación (contrata, honorario, o planta),
            4) Elegir un intervalo de años, 5) Elegir Ministerio y Servicio.
            Después de activados estos filtros tanto las gráficas como las
            etiquetas con información se actualizan inmediatamente.
          </footer>
        </blockquote>
        <PowerBI
          url="https://app.powerbi.com/view?r=eyJrIjoiY2RhMjQ5M2ItNjE5Mi00MjYwLThiZjgtNjdjNDA5YzBiZDhjIiwidCI6ImI1ZDc4OTI3LTI1ZDAtNDRhOS04MzcwLWQ4NmU1N2M3YmE5NiIsImMiOjR9"
        />
        <br /><br /><br />

        <blockquote class="blockquote">
          <p class="lead">
            COMPARACIONES
          </p>
          <footer class="blockquote-footer">
            Este visor consta de cuatro partes:<br />
            <b>Visor 1 y 2:</b> Comparación de
            <strong>Remuneraciones</strong> promedios por Ministerio y Servicio
            respectivamente
            <br />
            <b>Visor 2 y 4:</b> Comparación de <strong>Dotación</strong> por
            Ministerio y Servicio respectivamente.
            <br />
            De manera dinámica se posicionan los primeros 20 servicios con los
            valores más altos. Haciendo uso de los filtros se puede hacer
            seguimiento a uno o varios servicios de interés a través de los
            años. También se puede filtrar por Sexo y Régimen.<br /><br />
            Para navegar entre visores se utilizan los links en la parte
            inferior del tablero.
          </footer>
        </blockquote>
        <PowerBI
          url="https://app.powerbi.com/view?r=eyJrIjoiMjFkZjViY2UtODBiYi00NGIxLTgxY2MtMThhNGMzMmYwM2I3IiwidCI6ImI1ZDc4OTI3LTI1ZDAtNDRhOS04MzcwLWQ4NmU1N2M3YmE5NiIsImMiOjR9&pageName=ReportSection891cd0403a420ce383ce"
        />
        <br /><br /><br />
      </b-container>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "../../components/layout/Navbar";
import Header from "./components/header/Header.vue";
import PowerBI from "./components/powerbi/PowerBI.vue";
import NavBar2 from "./components/Navbar.vue";
import Footer from "./components/Footer.vue";

export default {
  components: {
    Navbar,
    Header,
    PowerBI,
    NavBar2,
    Footer
  }
};
</script>

<style scoped>
p {
  font-family: Georgia, serif;
  font-size: 1.1rem;
  line-height: 1.8rem;
  margin: 2rem 0;
}

.lead {
  font-size: 1.7rem;
  margin: 3.4rem 0 1.7rem 0;
  padding-bottom: 1.7em;
  font-family: sans-serif;
}

.center {
  text-align: center;
}

.blockquote .lead {
  font-weight: bold;
  color: #bdc3c7;
}

.blockquote-footer::before {
  content: "";
}

strong {
  color: #980100;
}

p {
  font-size: 0.875em;
  color: #6c757d;
  font-family: "Fira Sans", sans-serif;
  font-size: 17.5px;
}
</style>
